/* eslint-disable */
import envGet from '../../Support/Env/Get/EnvGet.support';

export const DELIVERY_PERSIST_KEY = `bds:delivery`;

export const DELIVERY_SERVICE_BASE_URL = envGet({ key: `REACT_APP_DELIVERY_SERVICE_BASE_URL` });

export const DELIVERY_ORDER_STATUS_ALL = `ALL`;
export const DELIVERY_ORDER_STATUS_COMPLETED = `COMPLETED`;
export const DELIVERY_ORDER_STATUS_DELIVERED = `DELIVERED`;
export const DELIVERY_ORDER_STATUS_LIVE = `LIVE`;
export const DELIVERY_ORDER_STATUS_SCHEDULED = `SCHEDULED`;
